export default {
    getCurrentLocation: function () {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((data) => {
                var lat = data.coords.latitude;
                var lng = data.coords.longitude;
                resolve({lat: lat, lng: lng});
            }, (error) => {
                reject(error);
            });
        });
    },
    getGeoLocation: function (lat,lng,localeShot,geocoder) {
        return new Promise((resolve,reject) => {
            var latlng = { lat: lat, lng: lng };
            geocoder.geocode({'location': latlng, 'language': localeShot }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    resolve(results[0]);
                } else {
                    reject(status);
                }
            } else {
                resolve();
            }
            });
        });
    },
};
